var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowL = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.156939 3.75025L3.20381 0.703374C3.30836 0.598825 3.43532 0.54655 3.58467 0.54655C3.73403 0.54655 3.86098 0.598825 3.96553 0.703374L4.45841 1.21865C4.56296 1.3232 4.61523 1.45016 4.61523 1.59951C4.61523 1.74887 4.56296 1.87582 4.45841 1.98037L2.30767 4.13111L4.45841 6.28184C4.56296 6.38639 4.61523 6.51335 4.61523 6.6627C4.61523 6.81206 4.56296 6.93901 4.45841 7.04356L3.96553 7.55884C3.86098 7.66339 3.73403 7.71567 3.58467 7.71567C3.43532 7.71567 3.30836 7.66339 3.20381 7.55884L0.156939 4.51197C0.0523897 4.40742 0.00011485 4.28047 0.000114848 4.13111C0.000114846 3.98175 0.0523897 3.8548 0.156939 3.75025Z",
    fill: "#00A8E1"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowL, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrowL.01c824b3.svg";
export { ForwardRef as ReactComponent };